import { Box, CircularProgress } from "@mui/material";
import type { FC } from "react";

type LoadingProps = {
	size?: string | number;
};

export const Loading: FC<LoadingProps> = ({ size }) => {
	return (
		<Box width={size ?? "20px"} height={size ?? "20px"}>
			<CircularProgress size={size ?? "20px"} />
		</Box>
	);
};
